import { makeStyles } from '@material-ui/core/styles';

// MuiInput
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '0 !important',
        color: '#768093',
        '&.MuiOutlinedInput-root': {
            color: '#252529',
            borderRadius: '4px', //theme.border.medium.radius,
            borderWidth: '1px', //theme.border.medium.width,
            borderColor: "#99a5bd",
            borderStyle: 'solid', //theme.border.medium.style,
        },
    },
    disabled: {
        backgroundColor: '#ddd',
        opacity: 0.8,
    },
}));

// MuiInputLabel
export const useLabelStyles = makeStyles((theme) => ({
    root: {
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '.75rem',
        letterSpacing: '.9px',
        marginBottom: '0px',
    },
    outlined: {
        textTransform: 'none',
        fontWeight: 400,
        fontSize: '.85rem',
        letterSpacing: 'normal',
        marginBottom: '8px',
    },
    filled: {},
    focused: {
        color: '#99a5bd !important',
    },
}));

export default useStyles;
